import { FiExternalLink } from "react-icons/fi";

interface props {
  blogItem: {
    title: string;
    guid: string;
    thumbnail: string;
    pubDate: string;
    description: string;
  };
}

export default function BlogItem({ blogItem }: props) {
  const { title, guid, thumbnail, pubDate, description } = blogItem;

  const monthNames: string[] = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "June",
    "Jul",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];

  //remove all the html tag
  const blogDesc: string = description.replace(/<[^>]*>/g, "");

  const getDate = (pubdate: string): string => {
    const dateObj = new Date(pubdate);
    let month = monthNames[dateObj.getMonth() - 1];
    let date = dateObj.getDate();
    let year = dateObj.getFullYear();

    return `${date} ${month}, ${year}`;
  };

  return (
    <article className="grid grid-cols-3 gap-5 mb-5">
      <div>
        <img
          className="w-64 sm:h-28 rounded-md lazyload object-cover"
          data-src={thumbnail}
          alt="blog thumbnail"
        />
      </div>

      <div className="col-span-2">
        <h3 className="font-bold sm:text-lg dark:text-white">{title}</h3>
        <span className="text-subText text-sm dark:text-dark_text">
          {getDate(pubDate)}
        </span>
        <p className="text-subText hidden sm:inline text-sm sm:text-base font-medium dark:text-dark_text">
          {blogDesc.substring(0, 100) + "..."}
        </p>
        <a
          rel="noreferrer"
          target="_blank"
          href={guid}
          className="flex items-center text-sm sm:text-base mt-3 text-primary"
        >
          learn more{" "}
          <span className="ml-2">
            <FiExternalLink />
          </span>
        </a>
      </div>
    </article>
  );
}
